import { Validators } from "@angular/forms";
export class ReportFormBuilder {
    formBuilder;
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
    }
    initReportForm() {
        return this.formBuilder.group({
            reportType: this.initReportType(),
            reportParameters: this.initReportParameters()
        });
    }
    initReportType() {
        return this.formBuilder.group({
            reportGroup: [null, Validators.required],
            reportID: [null, Validators.required],
            moduleId: [null, []],
            jobId: [null, []],
            uploadReport: [false, []],
            canDownloadInPortal: [false, []],
            componentType: [null, []]
        });
    }
    initReportParameters() {
        return this.formBuilder.group({
            reportDataInfo: this.formBuilder.array([]),
            reportCriteria: this.formBuilder.array([]),
            exportType: [null, [Validators.required]],
        });
    }
}
